
export default class Constants {

  public static username = 'username';
  public static uid = 'uid';

}